import './addressWithChanges.scss';

export const AddressWithChanges = angular
    .module('checkout.components.addressWithChanges', [])
    .component('addressWithChanges', {
        template: `
        <div class="address__address">
            <span ng-class="{
                'address__address-changed':$ctrl.changes['address1'],
                'address__address-changed--error':$ctrl.asError && $ctrl.changes['address1']
            }">
                {{$ctrl.changes['address1'] || $ctrl.address.address1}}
            </span>
            <span ng-class="{
                'address__address-changed':$ctrl.changes['address2'],
                'address__address-changed--error':$ctrl.asError && $ctrl.changes['address2']
            }">
                {{$ctrl.changes['address2'] || $ctrl.address.address2}}
            </span>
            <span ng-class="{
                'address__address-changed':$ctrl.changes['city'],
                'address__address-changed--error':$ctrl.asError && $ctrl.changes['city']
            }">
                {{$ctrl.changes['city'] || $ctrl.address.city}}
            </span>
            <span ng-class="{
                'address__address-changed':$ctrl.changes['state'],
                'address__address-changed--error':$ctrl.asError && $ctrl.changes['state']
            }">
                {{$ctrl.changes['state'] || $ctrl.address.state}}
            </span>
            <span ng-class="{
                'address__address-changed':$ctrl.changes['country'],
                'address__address-changed--error':$ctrl.asError && $ctrl.changes['country']
            }">
                {{$ctrl.changes['country'] || $ctrl.address.country}}
            </span>
            <span ng-class="{
                'address__address-changed':$ctrl.changes['postalCode'],
                'address__address-changed--error':$ctrl.asError && $ctrl.changes['postalCode']
            }">
                {{$ctrl.changes['postalCode'] || $ctrl.address.postalCode}}
            </span>
        </div>
        `,
        bindings: {
            address: '<',
            changes: '<',
            asError: '<'
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/addressVerificationForm/addressWithChanges.js